import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { DocumentaryResourceVM } from "@shared-kernel/domain/types/documentary-resource";

export const documentaryResourcesRetrieve = createAsyncThunk<DocumentaryResourceVM[], void, { extra: Partial<Dependencies> }>(
  "documentaryResource/retrieve",
  async (_: void, { extra: { sharedRepository } }) => {
    return sharedRepository!.getVisibleDocumentaryResources();
  },
);
